// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1_esbuild@0.27.2_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1_esbuild@0.27.2_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-center {
  text-align: center;
}

.margin-top {
  margin-top: 1rem;
}

.buttons {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
}

.btn-large {
  display: block;
  width: 40%;
  margin: 10px auto;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/modals/time-picker/time-picker.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,UAAA;EACA,iBAAA;AACF","sourcesContent":[".text-center {\n  text-align: center;\n}\n\n.margin-top {\n  margin-top: 1rem;\n}\n\n.buttons {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-evenly;\n  align-items: center;\n}\n\n.btn-large {\n  display: block;\n  width: 40%;\n  margin: 10px auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
